var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-title',{staticClass:"iq-color poppins px-0"},[_c('span',[_vm._v("Showing ⁡")]),_c('span',[_vm._v(" "+_vm._s(_vm.perPage * _vm.page - _vm.perPage + 1)+" to "+_vm._s(_vm.toPage ? _vm.toPage : "1")+" of "+_vm._s(_vm.totalNumber ? _vm.totalNumber : "1")+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }